export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
            关于被窝网电影
          </h2>

          <div className="bg-background-100 border border-background-200/70 rounded-xl p-6 md:p-8 text-left">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              被窝网电影大全诞生于影迷对高品质免费观影体验的共同追求。我们聚合全网优质影视资源，致力于打造一个<strong className="text-foreground-900">无需注册、无需付费、无广告打扰</strong>的纯粹观影平台。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台目前已收录超过<strong className="text-primary-600">两万部</strong>影视作品，涵盖电影、电视剧、动漫、综艺、纪录片等全品类内容。从院线新片到经典老片，从国产热剧到海外佳作，你都能在这里找到。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              我们坚持<strong className="text-foreground-900">每日更新</strong>，第一时间同步最新资源。技术团队持续优化播放引擎，采用多线路智能切换和自适应码率技术，确保每一位用户都能获得流畅稳定的观影体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              被窝网电影——<strong className="text-primary-600">让每一次观影都成为享受</strong>。
            </p>
          </div>

          <div className="grid grid-cols-3 gap-4 mt-8 max-w-md mx-auto">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">20,000+</div>
              <div className="text-xs text-foreground-500 mt-1">影视资源</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600">每日更新</div>
              <div className="text-xs text-foreground-500 mt-1">内容同步</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">全免费</div>
              <div className="text-xs text-foreground-500 mt-1">无需注册</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}